function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M36.7,49H26.4c-3.6,0-7-1.4-9.6-4c-2.6-2.6-4-6-4-9.6V21.6h3v13.9c0,2.8,1.1,5.5,3.1,7.5c2,2,4.6,3.1,7.5,3.1h10.3 c2.8,0,5.5-1.1,7.5-3.1c2-2,3.1-4.6,3.1-7.5V21.6h3v13.9c0,3.6-1.4,7-4,9.6C43.7,47.6,40.3,49,36.7,49z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M36.9,42.8H26.1c-3.9,0-7.1-3.2-7.1-7.1V7.4c0-3.9,3.2-7.1,7.1-7.1h10.8c3.9,0,7.1,3.2,7.1,7.1v28.3 C44,39.6,40.8,42.8,36.9,42.8z M26.1,3.3c-2.3,0-4.1,1.8-4.1,4.1v28.3c0,2.3,1.8,4.1,4.1,4.1h10.8c2.3,0,4.1-1.8,4.1-4.1V7.4 c0-2.3-1.8-4.1-4.1-4.1H26.1z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M37,35.8H26V7.3h11V35.8z M29,32.8h5V10.3h-5V32.8z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 30,
  y: 47.5,
  width: 3,
  height: 10.7
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 21.1,
  y: 56.7,
  width: 20.8,
  height: 3
})))));

var SvgMicrophone = function SvgMicrophone(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/microphone.4bdc7899.svg";
export { SvgMicrophone as ReactComponent };